import {
    trigger,
} from '@utils/event';
import {
    addModifier,
    getMouseType,
} from './convert-key';

let singleClickA: NodeJS.Timeout|null = null;
let singleClickB: NodeJS.Timeout|null = null;
let dblClickFlagA = false;
let dblClickFlagB = false;

function singleClick(e) {
    if (singleClickA) clearTimeout(singleClickA);
    singleClickA = setTimeout(() => {
        if (!dblClickFlagA) {
            trigger(addModifier(e).concat(getMouseType(e))
                .concat('sglclick'));
        }
        dblClickFlagA = false;
    }, 300);
}

function singleClickBubble(e, option?) {
    if (singleClickB) clearTimeout(singleClickB);
    singleClickB = setTimeout(() => {
        if (!dblClickFlagB) {
            trigger(addModifier(e).concat(getMouseType(e))
                .concat('sglclick', 'bubble'));
        }
        dblClickFlagB = false;
    }, 300);
}

window.addEventListener('click', (e) => {
    trigger(addModifier(e).concat(getMouseType(e))
        .concat('click'), e);

    // single click 逻辑
    singleClick(e);
}, true);

window.addEventListener('click', (e) => {
    trigger(addModifier(e).concat(getMouseType(e))
        .concat('click', 'bubble'), e);

    // single click 逻辑
    singleClickBubble(e, { bubble: true });
});

window.addEventListener('dblclick', (e) => {
    dblClickFlagA = true;
    dblClickFlagB = true;
    trigger(addModifier(e).concat(getMouseType(e))
        .concat('dblclick'), e);
}, true);

window.addEventListener('dblclick', (e) => {
    trigger(addModifier(e).concat(getMouseType(e))
        .concat('dblclick', 'bubble'), e);
});

window.addEventListener('mouseup', () => {
    // console.log('dblclick')
    // console.log(e)
}, true);

window.addEventListener('mousedown', () => {
    // console.log('dblclick')
    // console.log(e)
}, true);

window.addEventListener('wheel', (e) => {
    trigger(addModifier(e).concat('wheel'), e);
}, true);

window.addEventListener('wheel', (e) => {
    trigger(addModifier(e).concat('wheel', 'bubble'), e);
});
